import { useCallback, useEffect, useState } from 'react';

const storageKey = 'live_event_visibility';

export type VisibilityInfo = Record<string, boolean>;

export const useLifeEventVisibility = () => {
  const [info, setInfo] = useState<VisibilityInfo>({});

  useEffect(() => {
    const savedInfo = sessionStorage.getItem(storageKey);
    if (savedInfo) setInfo(JSON.parse(savedInfo));
  }, []);

  const setItemVisibility = useCallback((id: string, val: boolean) => {
    setInfo((prev) => {
      const newInfo = { ...prev, [id]: val ?? !prev[id] };
      sessionStorage.setItem(storageKey, JSON.stringify(newInfo));
      return newInfo;
    });
  }, []);

  return { visibilityInfo: info, setItemVisibility };
};
